Ext.define('SA.view.legend.Businesses', {
    alias: 'widget.legend-businesses',
    extend: 'Ext.Component',

    cls: 'sa-legend-businesses',

    tpl: [
        '<span class="sa-legend-businesses-icon-wrap">',
            '<span class="sa-legend-businesses-icon"></span>',
        '</span>',
        '<span class="sa-legend-businesses-name">{name}</span>',
        '<a aria-label="remove" class="sa-legend-businesses-remove" data-qtip="Click to remove businesses from this view" role="button">',
            '<svg aria-hidden="true" class="sa-legend-businesses-remove-icon">',
                '<use href="#sa-icon-close"></use>',
            '</svg>',
        '</a>'
    ],

    initEvents() {
        this.callParent();

        this.el.on('click', this.removeSearch, this, {delegate: '.sa-legend-businesses-remove'});

        this.el.on({
            delegate: '.sa-legend-businesses-name',
            scope: this,

            click: this.renameSearch,
            mouseout: this.onNameMouseOut,
            mouseover: this.onNameMouseOver
        });
    },

    onNameMouseOut(ev, el) {
        Ext.fly(el).removeCls('sa-legend-businesses-name-over');
    },

    onNameMouseOver(ev, el) {
        Ext.fly(el).addCls('sa-legend-businesses-name-over');
    },

    removeSearch() {
        var map = this.up('map-legend').map;

        map.setBusinessSearch(null);
    },

    renameSearch() {
        var menu = this.lastMenu,
            legend = this.up('map-legend');

        if (legend.isDrag) {
            return;
        }

        if (menu && menu.wasRecentlyVisible()) {
            return;
        }

        legend.addCls('sa-legend-active');

        var map = legend.map,
            businessSearch = SA.data.BusinessSearches.get(map.getBusinessSearch()),
            name = businessSearch.name;

        menu = this.lastMenu = Ext.widget({
            xtype: 'arrow-menu',

            alignment: 'left/right',
            enableKeyNav: false,
            padding: '3 5',
            positionEl: this.el.down('.sa-legend-businesses-name').dom,
            target: this,
            track: true,
            width: 300,

            listeners: {
                destroy() {
                    legend.removeCls('sa-legend-active');
                }
            },

            items: [
                {
                    xtype: 'sa-textfield',
                    fieldLabel: 'Rename',
                    labelWidth: 70,
                    maxLength: 30,
                    value: name,

                    listeners: {
                        beforedestroy(field) {
                            var value = field.getValue().trim();

                            if (value) {
                                SA.data.BusinessSearches.setName(businessSearch, value);
                            }
                        },

                        boxready(field) {
                            field.focus(true, true);
                        },

                        specialkey(field, ev) {
                            switch (ev.getKey()) {
                                case ev.ENTER:
                                    field.up('arrow-menu').destroy();
                                break;

                                case ev.ESC:
                                    field.setValue(name);
                                    field.up('arrow-menu').destroy();
                                break;
                            }
                        }
                    }
                }
            ]
        });
    }
});
